function GARU( c, name, getGroup ) {
  c[`GET_${name}`] = `GET_${name}`
  ARU( c, name )
  if ( getGroup ) {
    c[`GET_${name}S`] = `GET_${name}S`
    c[`GET_${name}S_STATUS`] = `GET_${name}S_STATUS`
  }
}

function ARU( c, name ) {
  c[`ADD_${name}`] = `ADD_${name}`
  c[`REMOVE_${name}`] = `REMOVE_${name}`
  c[`UPDATE_${name}`] = `UPDATE_${name}`
}

function set( c, name ) {
  c[name] = name
}

const c = {}

GARU( c, 'RESOURCE', true )
GARU( c, 'BLUEPRINT', true )
GARU( c, 'PROJECT' )
GARU( c, 'PROJECT_ACCOUNT', true )
GARU( c, 'CONTACT', true )
GARU( c, 'SYSTEM_USER', true )
GARU( c, 'SYSTEM', true )
GARU( c, 'API_ACCESS', true )
GARU( c, 'DEVICE', true )

GARU( c, 'NETWORK', true )
set( c, 'GET_SHARED_NETWORKS' )
ARU( c, 'CONTACT' )
GARU( c, 'API_ACCESS' )

set( c, 'GET_SCRIPT_LOGS' )
set( c, 'GET_SCRIPT_LOGS_STATUS' )

GARU( c, 'TIMER', true )
GARU( c, 'SCRIPT', true )
GARU( c, 'TEMPLATE', true )
GARU( c, 'USER', true )
GARU( c, 'GEOTILE', true )

GARU( c, 'MESSAGE_ROUTE', true )

set( c, 'STATUS_LOADING' )
set( c, 'STATUS_DONE' )
set( c, 'STATUS_ERROR' )

module.exports = c
